// extracted by css-extract-rspack-plugin
export default {"options":"DZ1DE","option":"nnwsO","empty":"h8XUU","groupLabel":"GzqqR","chevron":"YfJ8M"};